import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Forklift } from "@nxt-costco-com/forge-icons/icons/Forklift";
import { mdoContainerStyles, mdoWrapperStyles, mdoIconStyles, mdoTextDivStyles } from "./styles.js";
const MDOChannelBadge = ({
  uniqueId,
  translations
}) => {
  const { atproposition, pickuplabel, available, costcodistributioncenter } = translations || {};
  const atMDOText = `${atproposition} ${costcodistributioncenter}`;
  return /* @__PURE__ */ jsx(Box, { sx: mdoContainerStyles, children: /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `MDOChannelBadge_${uniqueId}`,
      sx: mdoWrapperStyles,
      children: [
        /* @__PURE__ */ jsx(Forklift, { sx: { color: ColorGray900, ...mdoIconStyles } }),
        /* @__PURE__ */ jsxs(Box, { sx: mdoTextDivStyles, children: [
          /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: pickuplabel }),
          /* @__PURE__ */ jsx(Text, { color: "success", variant: "t7", children: available }),
          /* @__PURE__ */ jsx(Text, { variant: "t7", children: atMDOText })
        ] })
      ]
    }
  ) });
};
export {
  MDOChannelBadge
};
